export const INVISI_ADDR = "0x76794190540b6666D669A40A25705731C47cc67C";
export const STAKING_ADDR = "0xd54Fb9A6e99505eeaD448CAb67085127D7528457";
export const MULTICALL_ADDR = "0x77dCa2C955b15e9dE4dbBCf1246B4B85b651e50e";
